import PDF from './pdf'
import { formatAccounting, capitalizeFirstLetter, getCurrentDateEnUsFormat } from '../lib/utils'

export default class SaleDailyInsight extends PDF {
  /**
   * Description
   * @param {import('jspdf').DocumentProperties} args
   */
  constructor(args = {}) {
    super()
    this.doc.setProperties({
      unit: 'mm',
      format: 'a4',
      ...args,
    })
    this.addFonts()
  }

  /**
   * Description
   * @param {boolean} [cancel]
   */
  __header({ storeName = '', dateRange = '' }) {
    const title = `${capitalizeFirstLetter(storeName)} Sales Insight Report`
    this.centerText({ fontSize: 24, text: title, yOffset: 15, color: [55, 71, 79] })
    this.centerText({ fontSize: 12, text: dateRange, yOffset: 22 })
    this.doc.setFillColor('#CFD8DC')
    this.doc.line(15, 25, 195, 25, 'F')
  }

  /**
   * Description
   * @param {HeadingData} subHeader
   * @returns {void}
   */
  __subHeader(subHeader) {
    const { grossProfit = '', totalCost = '', revenue = '', brandTypeAmounts = {} } = subHeader || {}
    const [x, y] = [15, 40]
    const delimiter = ':'

    const brandTypes = Object.keys(brandTypeAmounts)

    const { labelWidth: textLength } = this.generateField({
      label: 'Gross Revenue',
      value: revenue,
      coordinates: [x, y + (5 * (brandTypes.length + 2))],
      delimiter,
    })


    let counter = 0
    brandTypes.forEach((brandType) => {
      this.generateField({
        label: brandType,
        value: brandTypeAmounts[brandType],
        coordinates: [x, y + (5 * counter)],
        textLength,
        delimiter,
      })
      counter++
    })

    this.generateField({
      label: 'Total Cost',
      value: totalCost,
      coordinates: [x, y + (5 * counter++)],
      textLength,
      delimiter,
    })

    this.generateField({
      label: 'Gross Profit',
      value: `${grossProfit}`,
      coordinates: [x, y + (5 * counter)],
      textLength,
      delimiter,
    })
  }

  /**
   * Description
   * @param {{ totalAmount: number; }} params
   * @param {ReceiptItem} body
   * @returns {any}
   */
  __table({ headers }, body) {
    this.doc.autoTable({
      styles: {
        fontSize: 6,
      },
      head: [headers],
      startY: 70,
      body: [
        ...body,
      ],
    })
  }

  /**
   * Description
   * @param {string} receiptNo
   * @returns {void}
   */
  __save(storeName) {
    const name = `${storeName.replace(/[\s]+/g, '_')}_daily_sales_insight_${new Date().getTime()}`
    this.doc.save(name.toLocaleLowerCase())
  }

  /**
   * Description
   * @param {HeadingData} data
   * @param {Item[]} items
   * @returns {any}
   */
  generate(data, items) {
    this.__header(data)
    this.__subHeader(data)
    this.__table(data, items)
    this.__save(data.storeName)
  }
}

/**
 * @typedef {{[key: string]: number}} brandTypeAmount
 * 
 * @typedef HeadingData
 * @property {number} storeName
 * @property {string} dateRange
 * @property {string} revenue
 * @property {number} totalCost
 * @property {string} grossProfit
 * @property {brandTypeAmount} brandTypeAmounts
 * @property {string} grossProfitMargin
 * 
 * @typedef {string|object} Item
 */
